// extracted by extract-css-chunks-webpack-plugin
module.exports = {"descriptionContainer":"descriptionContainer___DxUOv","headline":"headline___29I_E","text":"text___2yPKc","popoverStyle":"popoverStyle___1AO7e"};